import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class AppearAnimation {
	static instance = null;

	static create(options) {
		if (!AppearAnimation.instance) {
			AppearAnimation.instance = new AppearAnimation(options);
		}
		return AppearAnimation.instance;
	}

	static destroy() {
		if (AppearAnimation.instance) {
			AppearAnimation.instance.beforeDestroy();
			AppearAnimation.instance = null;
		}
	}

	static getDefaultOptions() {
		return {
			container: null,
			selector: null,
		}
	}

	constructor(options) {
		this.options = Object.assign({}, AppearAnimation.defaultOptions, options);
		this.init();
	}

	init() {
		this.initAppearBlocks();
		this.initAppearSequence();


		setTimeout(() => {
			this.initApperList();
		}, 300);
	}

	initAppearBlocks() {
		this.appearBlocks = [...this.options.container.querySelectorAll("[data-appear-block]")];

		if (this.appearBlocks.length > 0 || this.appearBlocks !== null) {
			this.appearBlocks.forEach(box => {
				const effect = box.dataset.appearBlock;
				const distance = box.dataset.appearDistance || 100;
				const toggleActions = box.hasAttribute('data-appear-reverse') ? `play none none reverse` : `play none none none`;
				const delay = box.dataset.appearDelay || 0

				let tl = gsap.from(box, {
					scrollTrigger: {
						trigger: box,
						start: "top 80%",
						end: "bottom 20%",
						scroller: "[data-scroll-container]",
						markers: false,
						toggleActions: toggleActions,

					},
					y: effect !== 'fadein' ? distance : 0,
					autoAlpha: 0,
					duration: 1,
					ease: 'power1.out',
					delay: delay,
					clearProps: 'all',
					onComplete: (a) => {
						tl.scrollTrigger.kill();
						tl.kill();
						tl = null;
						box.style.willChange = 'auto';
					}
				})
			})
		}
	}

	initAppearSequence() {
		this.appearSequenced = [...this.options.container.querySelectorAll("[data-appear-sequenced]")];

		if (this.appearSequenced.length > 0 || this.appearSequenced !== null) {

			this.appearSequenced.forEach(box => {
				const delay = box.dataset.appearDelay || 0
				const stagger = box.dataset.appearStagger || 0.1
				const distance = box.dataset.appearDistance || 200
				const toggleActions = box.hasAttribute('data-appear-reverse') ? `play none none reverse` : `play none none none`;
				let items = box.querySelectorAll('[data-appear-item]');
				if(!items.length && box.dataset.appearSequenced === 'all' && box.children.length > 0) {
					items = [...box.children];
				}
				this.button = box.querySelectorAll('.btn-hold');
				if (!!items.length) {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: box,
							start: "top 90%",
							end: "bottom 10%",
							scroller: "[data-scroll-container]",
							markers: false,
							toggleActions: toggleActions,

						}, onComplete: (a) => {
							tl.scrollTrigger.kill();
							tl.kill();
							tl = null;
							box.style.willChange = 'auto';
							items.forEach(item => {
								item.style.willChange = 'auto';
							});

						},
					}).from(items, {
						y: distance,
						opacity: 0,
						duration: 0.8,
						ease: 'power1.out',
						delay: delay,
						stagger: stagger,
						clearProps: 'all',
						overwrite: true,
					})

					if (this.button.length > 0) {
						tl.from(this.button, {y: 50, alpha: 0});
					}

				}
			});
		}
	}

	initApperList() {
		const isMobile = window.innerWidth < 768;
		this.appearList = [...this.options.container.querySelectorAll("[data-appear-list]:not(.list-animated)")];
		if (this.appearList.length > 0) {
			this.appearList.forEach(box => {
				const delay = box.dataset.appearDelay || 0.1;

				const disableMobile = box.hasAttribute('data-disable-mobile') ? true : false;
				if (disableMobile && isMobile) {
					box.style.willChange = 'auto';
					box.style.opacity = 1;
					box.style.transform = 'translateY(0)';
					box.style.visibility = 'visible';
					return;
				}

				let tl = gsap.to(box, {
					scrollTrigger: {
						trigger: box,
						start: "0% 97%",
						end: "100% 3%",
						scroller: "[data-scroll-container]",
						markers: false,

					},
					y: 0,
					autoAlpha: 1,
					duration: isMobile ? 0.35 : 0.75,
					ease: isMobile ? 'power1.out' : 'circ.out',
					delay: delay,
					onStart: (a) => {
						box.classList.add('list-animated');
					},
					onComplete: (a) => {
						tl.scrollTrigger.kill();
						tl.kill();
						tl = null;
						box.style.willChange = 'auto';
					},
				})
			})
		}
	}

	beforeDestroy() {
		if (this.appearBlocks.length > 0) {
			this.appearBlocks = null;
			this.appearSequenced = null;
			this.button = null;
			this.appearList = null;
		}

	}
}

export default AppearAnimation;
